module.exports = __webpack_public_path__ + "img/W-cpm158.84596a3f.jpg";